import { Message } from 'element-ui';
import router from '../../router'
import qs from 'qs'

/**
 * axios 基础设置
 */
switch (location.hostname) {
    case 'www.knowsafe.com' :case 'knowsafe.com' : case 'localhost' :     //正式服
        axios.defaults.baseURL = 'https://api.knowsafe.com/knowsafe';
        var api2Url='https://api2.knowsafe.com/knowsafescan';
        var itrust='https://itrust.knowsafe.com/';
        var imgurl='https://api.knowsafe.com/';
        break;
    default :                                           //测试服
        axios.defaults.baseURL = 'https://apitest.knowsafe.com/knowsafe';
        var api2Url='https://api2test.knowsafe.com/knowsafescan';
        // axios.defaults.baseURL = 'http://192.168.0.115:8086/knowsafe';
        // var api2Url='http://192.168.0.115:8086/knowsafescan';
        var itrust='https://itrusttest.knowsafe.com/';
        var imgurl='https://apitest.knowsafe.com/';
        break;
}

/**
 * 应用内部拦截器，请使用 inside.get()或inside.post()...
 * 不使用拦截器的，请使用 axios.get()或axios.post()...
 */
var inside = axios.create();
inside.interceptors.request.use(function (config) {
    config.data=JSON.stringify({param:config.data});
    let userInf=localStorage.getItem('userInf');
    console.log(userInf)
    if(userInf){
        userInf=JSON.parse(userInf);
        config.headers.userkeyid=userInf.Userkeyid;
        config.headers.token=userInf.Token;
    }
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    console.log(error);
    // 对请求错误做些什么
    return Promise.reject(error);
});
inside.interceptors.response.use(function (response) {
    if(typeof response.data=='string'){
        // 判断接口返回的错误码
        if(response.data.includes('token') || response.data.includes('invaild user') || response.data.includes('empty user') || response.data.includes('lock user')){
            response.data={
                response:{
                    status:10001,
                    data:{
                        message:'登录失效'
                    }
                }
            }
        }
        else if(response.data.includes('error7')){
            response.data={
                response:{
                    status:501,
                    data:{
                        message:'该服务仅对企业实名认证用户开放'
                    }
                }
            }
        }
    }

    switch (response.data.response.status) {
        case 1:case 2:
            return response.data.response.data;
        case 10001:case 20003:
            Message.error('登录已失效，请重新登录！');
            localStorage.setItem('userInf','');
            if(process.env.NODE_ENV=='development'){
                router.push({name:'login'});
            }else{
                if(router.history.current.query.jump){
                    location.href='../login.shtml?url='+router.history.current.query.jump;
                }else{
                    location.href='../login.shtml';
                }
            }
            return Promise.reject(response.data.response.data.message);
        case 501:
            Message.error('该服务仅对企业实名认证用户开放');
            router.push({ name: 'authentication' });
            return Promise.reject(response.data.response.data.message);
        default:
            Message.error(response.data.response.message);
            // return response.data.response;
            return Promise.reject(response.data.response.data.message);
    }
    return response.data.response.data;
}, function (error) {
    console.log(error);
    //网络错误
    if(error.message.includes('429')){
        Message.error(`您的操作过于频繁`);
        return Promise.reject(error);
    }
    //网络错误
    if(error.message.includes('Network')){
        Message.error(`网络错误`);
        return Promise.reject(error);
    }
    //接口请求超时
    if(error.message.includes('timeout')){
        Message.error(`接口请求状态超时`);
        return Promise.reject(error);
    }
    Message.error(`接口${error.response.config.url}请求状态${error.response.status}`);
    return Promise.reject(error);
});
/**
 * 图片上传AXIOS封装
 */
var formdata = axios.create();
formdata.interceptors.request.use(function (config) {
    let userInf=localStorage.getItem('userInf');
    if(userInf){
        userInf=JSON.parse(userInf);
        config.headers.userkeyid=userInf.Userkeyid;
        config.headers.token=userInf.Token;
    }
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
formdata.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    switch (response.data.response.status) {
        case 1:case 2:
            return response.data.response.data;
        case 10001:case 20003:
            Message.error('登录已失效，请重新登录！');
            window.location.href='../login.shtml';
            // router.push({name:'login'});
            return Promise.reject(response.data.response.data.message);
        default:
            Message.error(response.data.response.message);
            return Promise.reject(response.data.response.data.message);
    }
}, function (error) {
    // Message.error('登陆已失效，请重新登陆！');
    // router.push({name:'login'});
    // return false
    // //网络错误
    // if(error.message.includes('Network')){
    //     Message.error(`网络错误`);
    //     return Promise.reject(error);
    // }
    // //接口请求超时
    // if(error.message.includes('timeout')){
    //     Message.error(`接口请求状态超时`);
    //     return Promise.reject(error);
    // }
    // Message.error(`接口${error.response.config.url}请求状态${error.response.status}`);
    // return Promise.reject(error);
});
/**
 * 接口API
 */
export default {
    imgurl:imgurl,
    //公司登陆
    loginCompany:function (params) {
        return inside.post(`/reg/companylogin`,params)
    },
    //获取公司信息
    etcompanyinfo:function () {
        return inside.get(`/company/getcompanyinfo`)
    },
    //获取品牌设置和域名设置信息
    getcompanyinfobackup:function(){
        return inside.get(`/company/getcompanyinfobackup`)
    },
    //修改公司信息
    editCompanyInfo:function(params){
        return inside.post(`/company/modifycompanyinfo`,params)
    },
    //获取bug列表
    buglist:function (params) {
        return inside.post(`/company/getcompanybuglist`,params)
    },
    //审核bug
    companyCheckbug:function (params) {
        return inside.post(`/company/checkbug`,params)
    },
    //添加公告
    addsrc:function (params) {
        return inside.post(`/company/addsrc`,params)
    },
    //获取公告列表
    getsrclist:function (params) {
        return inside.post(`/company/getsrclist`,params)
    },
    //删除公告
    delsrc:function (params) {
        return inside.post(`/company/delsrc`,params)
    },
    //获取公告详情
    showSrc:function(params){
        return inside.post(`/help/getsrcbykey`,params)
    },
    //修改公告
    editSrc:function (params) {
        return inside.post(`/company/modifysrc`,params)
    },
    //礼品列表
    goodsList:function (params) {
        return inside.post(`/company/getgoodslist`,params)
    },
    //添加礼品
    addgoods:function (params) {
        return inside.post(`/company/addgoods`,params)
    },
    //获取商品详情
    showGoods:function(params){
        return inside.post(`/company/getgoodsfromKey`,params)
    },
    //删除礼品
    delgoods:function (params) {
        return inside.post(`/company/deletegoods`,params)
    },
    //修改商品
    modifygoods:function (params) {
        return inside.post(`/company/modifygoods`,params)
    },
    //上传商品图片
    ploadgoodpic:function (data) {
        return formdata.post(`/company/uploadgoodpic`,data,{headers:{"Content-Type":"multipart/form-data"}})
    },
    //上传个人图片
    uploadheadpic:function (data) {
        return formdata.post(`/company/uploadheadpic`,data,{headers:{"Content-Type":"multipart/form-data"}})
    },
    //上传图片接口后期都用这个  uploadType 0:发票 1:用户认证
    upload:function (type,data) {
        return formdata.post(`/upload/upload?type=`+type,data,{headers:{"Content-Type":"multipart/form-data"}})
    },
    //上架下架商品
    goodsStatus:function (params) {
        return inside.post(`/company/updowngoods`,params)
    },
    //获取短信验证码
    sendcode:function (params) {
        return inside.post(`/veritfycode/sendcode`,params)
    },
    //修改密码
    modifypass:function (params) {
        return inside.post(`/company/modifypass`,params)
    },
    //修改创始人信息
    modifyceoinfo:function (params) {
        return inside.post(`/company/modifyceoinfo`,params)
    },
    //订单列表
    getorderlist:function (params) {
        return inside.post(`/company/getorderlist`,params)
    },
    //订单详情
    getorderfromkey:function (params) {
        return inside.post(`/company/getorderfromkey`,params)
    },
    //订单发货
    sendgoods:function (params) {
        return inside.post(`/company/sendgoods`,params)
    },
    //获取ssl订单列表
    sslList:function (params) {
        return inside.post(`/sslcert/getcertorderlist`,params)
    },
    //购买证书页面接口
    certbrand:function (params) {
        return inside.get(`/sslcert/getcertinfo`,params)
    },
    //获取即将购买的域名证书价格
    getcertprice:function(params){
        return inside.post(`/sslcert/getcertprice`,params)
    },
    //创建域名证书订单
    createsslcertorder:function (params) {
        return inside.post(`/sslcert/createsslcertorder`,params)
    },
    //确认订单 OR 证书详情
    certorderinfo:function (params) {
        return inside.post(`/sslcert/getcertorderinfo`,params)
    },
    //重新办法证书
    replaceeditsslcert:function (params) {
        return inside.post(`/sslcert/replaceeditsslcert`,params)
    },
    //支付订单包含了 ssl、资产
    payorder:function (params) {
        return inside.post(`/order/payorder`,params)
    },
    //ssl订单支付
    paysslcertorder:function (params) {
        return inside.post(`/sslcert/paysslcertorder`,params)
    },
    //获取支付状态
    getorderflag:function (params) {
        return inside.post(`/order/getorderflag`,params)
    },
    //确认签发证书
    issuesslcert:function (params) {
        return inside.post(`/sslcert/issuesslcert`,params)
    },
    //新增签发证书公司信息
    addcertorginfo:function (params) {
        return inside.post(`/sslcert/addcertorginfo`,params)
    },
    //新增签发证书订单联系人
    addcertcontactinfo:function (params) {
        return inside.post(`/sslcert/addcertcontactinfo`,params)
    },
    //获取公司联系人列表
    getcertorginfo:function (params) {
        return inside.post(`/sslcert/getcertorginfo`,params)
    },
    //修改公司联系人
    updatecertorginfo:function (params) {
        return inside.post(`/sslcert/updatecertorginfo`,params)
    },
    //获取订单联系人列表
    getcertcontactinfo:function (params) {
        return inside.post(`/sslcert/getcertcontactinfo`,params)
    },
    //修改订单联系人
    updatecertcontactinfo:function (params) {
        return inside.post(`/sslcert/updatecertcontactinfo`,params)
    },
    //解析SRC
    analysiscsr:function (params) {
        return inside.post(`/sslcert/analysiscsr`,params)
    },
    //下载信息确认函模板
    downloadconfirmlettertemp:function (params) {
        return inside.post(`/sslcert/downloadconfirmlettertemp`,params)
    },
    //下载信息确认函
    uploadconfirmletter:function (params) {
        return inside.post(`/sslcert/uploadconfirmletter`,params)
    },
    // 下载吊销确认函模板
    revokeletter:function (params) {
        return inside.post(`/sslcert/revokeletter`,params)
    },
    // 吊销证书
    revoke:function (params) {
        return inside.post(`/sslcert/revoke`,params)
    },
    // 取消订单
    cancelorder:function (params) {
        return inside.post(`/sslcert/cancelorder`,params)
    },
    // 获取证书pem详情
    cert_decode:function (params) {
        return inside.post(`/sslcert/parse`,params)
    },
    // 获取重新颁发证书列表
    getreplacesslcertinfos:function (params) {
        return inside.post(`/sslcert/getreplacesslcertinfos`,params)
    },
    // 一键续费
    renewsslcertorder:function (params) {
        return inside.post(`/sslcert/renewsslcertorder`,params)
    },
    // 下载证书
    getcertkey:function (params) {
        return inside.post(`/sslcert/getcertkey`,params)
    },
    // 下载证书 online 型的
    getkeystore:function (params) {
        return inside.post(`/sslcert/getkeystore`,params)
    },
    // 获取重新颁发证书详情
    replacesslcertinfo:function (params) {
        return inside.post(`/sslcert/replacesslcertinfo`,params)
    },
    //获取监控列表
    getmonitorlist:function(params){
        return inside.post(api2Url+`/domain/getmonitorlist`,params)
    },
    //添加资产
    adddomain:function(params){
        return inside.post(api2Url+`/domain/adddomain`,params)
    },
    //验证资产
    checkdomain:function(params){
        return inside.post(api2Url+`/domain/checkdomain`,params)
    },
    //获取资产列表
    getassetslist:function(params){
        return inside.post(api2Url+`/domain/getdomainlist`,params)
    },
    //删除资产
    deldomainmonitor:function(params){
        return inside.post(api2Url+`/domain/deldomainmonitor`,params)
    },
    //获取子域资产列表
    getsubdomainlist:function(params){
        return inside.post(api2Url+`/domain/getsubdomainlist`,params)
    },
    //添加分组
    addGroup:function(params){
        return inside.post(api2Url+`/domain/addgroup`,params)
    },
    //修改分组
    modifydomaingroup:function(params){
        return inside.post(api2Url+`/domain/modifydomaingroup`,params)
    },
    //获取分类列表
    getgrouplist:function(){
        return inside.get(api2Url+`/domain/getgrouplist`)
    },
    //获取域名资产详细信息
    getdomaininfo:function(params){
        return inside.post(api2Url+`/domain/getdomaininfo`,params)
    },
    //获取域名资产漏洞总览信息
    getdangermaininfo:function(params){
        return inside.post(api2Url+`/domain/getdangermaininfo`,params)
    },
    //获取资产漏洞列表
    getdomaindangerlist:function(params){
        return inside.post(api2Url+`/domain/getdomaindangerlist`,params)
    },
    //修改域名资产
    modifydomain:function(params){
        return inside.post(api2Url+`/domain/modifydomain`,params)
    },
    //获取域名资产漏洞总览信息
    getdangerlisthead:function(params){
        return inside.post(api2Url+`/domain/getdangerlisthead`,params)
    },
    //增加子域名
    addsubdomain:function(params){
        return inside.post(api2Url+`/domain/addsubdomain`,params)
    },
    //增加子域名到监控
    addsubmonitor:function(params){
        return inside.post(api2Url+`/domain/subtomonitor`,params)
    },
    //删除子域
    delsubdomaininfo:function (params) {
        return inside.post(api2Url+`/domain/delsubdomaininfo`,params)
    },
    //创建资产订单
    orderdomain:function (params) {
        return inside.post(api2Url+`/domainorder/orderdomain`,params)
    },
    //获取资产价格
    getdomainprice:function (params) {
        return inside.get(api2Url+`/domainorder/getdomainprice`,params)
    },
    //获取资产订单信息
    getorderinfofromkey:function (params) {
        return inside.post(api2Url+`/domainorder/getorderinfofromkey`,params)
    },
    //资产支付
    paydomainorder:function (params) {
        return inside.post(api2Url+`/domainorder/paydomainorder`,params)
    },
    //资产订单支付
    getassetsorderflag:function (params) {
        return inside.post(api2Url+`/domainorder/getorderflag`,params)
    },
    //使用优惠码
    ordervouchers:function (params) {
        return inside.post(`/order/ordervouchers`,params)
    },
    //子域资产生成订单
    ordersubdomain:function (params) {
        return inside.post(api2Url+`/domainorder/ordersubdomain`,params)
    },
    //资产续费
    reneworderdomain:function (params) {
        return inside.post(api2Url+`/domainorder/reneworderdomain`,params)
    },
    //获取我的钱包
    getwalletinfo:function(){
        return inside.post(`/wallet/getwalletinfo`)
    },
    //钱包充值
    recharge:function (params) {
        return inside.post(`/wallet/recharge`,params)
    },
    //收支明细
    paymentdetails:function (params) {
        return inside.post(`/wallet/paymentdetails`,params)
    },
    //查询发票信息
    queryinvoiceinfo:function (params) {
        return inside.post(`/invoice/queryinvoiceinfo`,params)
    },
    //新增发票信息
    addinvoicetitleinfo:function (params) {
        return inside.post(`/invoice/addinvoicetitleinfo`,params)
    },
    //修改发票信息
    updateinvoicetitleinfo:function (params) {
        return inside.post(`/invoice/updateinvoicetitleinfo`,params)
    },
    //删除发票
    deleteinvoiceinfo:function (params) {
        return inside.post(`/invoice/deleteinvoiceinfo`,params)
    },
    //申请发票
    applyinvoice:function (params) {
        return inside.post(`/invoice/applyinvoice`,params)
    },
    //设置支付密码
    setupwalletpwd:function (params) {
        return inside.post(`/wallet/setupwalletpwd`,params)
    },
    //查询初始化密码是否设置
    querywalletpwd:function (params) {
        return inside.post(`/wallet/querywalletpwd`,params)
    },
    //订单详情
    getorderinfo:function (params) {
        return inside.post(`/order/getorderinfo`,params)
    },
    //新增发票邮寄地址
    addinvoiceaddrinfo:function (params) {
        return inside.post(`/invoice/addinvoiceaddrinfo`,params)
    },
    //查询我的发票信息
    querymyinvoiceinfo:function (params) {
        return inside.post(`/invoice/querymyinvoiceinfo`,params)
    },
    //查询发票列表
    queryinvoicelist:function (params) {
        return inside.post(`/invoice/queryinvoicelist`,params)
    },
    //删除邮件地址
    deleteinvoiceaddrinfo:function (params) {
        return inside.post(`/invoice/deleteinvoiceaddrinfo`,params)
    },
    //修改邮件地址
    updateinvoiceaddrinfo:function (params) {
        return inside.post(`/invoice/updateinvoiceaddrinfo`,params)
    },
    //生成域名资产挂标内容
    createdomainlabel:function (params) {
        return inside.post(api2Url+`/domain/createdomainlabel`,params)
    },
    //生成域名资产挂标内容
    getdomaintxt:function (params) {
        return inside.post(api2Url+`/domain/getdomaintxt`,params)
    },
    //模糊查询域名
    getmydomain:function (params) {
        return inside.post(api2Url+`/domain/getmydomain`,params)
    },
    //添加深度监控
    adddeepmonitor:function (params) {
        return inside.post(api2Url+`/domain/adddeepmonitor`,params)
    },
    //安全报告列表
    getsafetylist:function (params) {
        return inside.post(`/safety/getsafetylist`,params)
    },
    //申请安全服务
    apply:function (params) {
        return inside.post(`/safety/apply`,params)
    },
    //获取费用中心订单管理
    getcostorderlist:function (params) {
        return inside.post(`/order/getorderlist`,params)
    },
    //续费管理列表
    getreneworderlist:function (params) {
        return inside.post(`/order/getreneworderlist`,params)
    },
    //获取实名认证信息
    getauthinfo:function () {
        return inside.post(`/userauth/getauthinfo`)
    },
    //提交认证信息
    authinfo:function (params) {
        return inside.post(`/userauth/authinfo`,params)
    },
    //修改认证信息
    modifyauthinfo:function (params) {
        return inside.post(`/userauth/modifyauthinfo`,params)
    },
    //升级为企业实名认证
    upgradecompanyauthinfo:function (params) {
        return inside.post(`/userauth/upgradecompanyauthinfo`,params)
    },
      //查询是否开通资产探测
    getdeepeyeopeninfo:function (params) {
        return inside.post(`/deepeye/open/info`,params)
    },
    //根据用户查询最新的未支付资产探测订单记录
    getunpaiddeepeyeinfo:function (params) {
        return inside.post(`/deepeye/order/info`,params)
    },//创建企业资产探测订单
    createAssetestingorder:function (params) {
        return inside.post(`/deepeye/order/create`,params)
    },
    getdeepeyelist:function (params) {
        return inside.post(`/deepeye/list`,params)
    },    
    //查询是否开通SRC
    getsrcopeninfo:function (params) {
        return inside.post(`/src/getsrcopeninfo`,params)
    },
    //创建企业SRC订单
    createsrcopenorder:function (params) {
        return inside.post(`/src/createsrcopenorder`,params)
    },
    //获取开通src订单详情
    getsrcinfo:function (params) {
        return inside.post(`/src/getsrcinfo`,params)
    },
    //根据用户查询最新的未支付src订单记录
    getunpaidsrcinfo:function (params) {
        return inside.post(`/src/getunpaidsrcinfo`,params)
    },
    //根据域名查询证书订单
    getcertorderbysrcurl:function (params) {
        return inside.post(`/sslcert/getcertorderbysrcurl`,params)
    },
    //修改域名设置
    modifycompanyinfodomain:function (params) {
        return inside.post(`/company/modifycompanyinfodomain`,params)
    },
    //获取域名资产详细信息
    getdomainscandangerinfo:function(params){
        return inside.post(api2Url+`/domain/getdomainscandangerinfo`,params)
    },
    //查询威胁情报通知订单详情
    gettinotifyorder:function(params){
        return inside.post(`/ti/gettinotifyorder`,params)
    },
    //威胁情报详情
    gettiinfo:function(params){
        return inside.post(`/ti/gettiinfo`,params)
    },
    //关闭威胁情报通知开关
    closetinotify:function(params){
        return inside.post(`/ti/closetinotify`,params)
    },
    //关闭威胁情报通知开关
    updatesubdomain:function(params){
        return inside.post(api2Url+`/domain/updatesubdomain`,params)
    },
    //订单管理里面的取消订单
    dcancelorder:function(params){
        return inside.post(`/order/cancelorder`,params)
    },
    //获取漏洞分类无需验证
    getallbugtype:function(params){
        return inside.post(`/help/getallbugtype`,params)
    },
    //威胁情报续费
    renewtinotifyorder:function(params){
        return inside.post(`/ti/renewtinotifyorder`,params)
    },
    //删除指纹
    deletetisubscribeinfo:function(params){
        return inside.post(`/ti/deletetisubscribeinfo`,params)
    },
    //升级套餐
    upgradetinotifyorder:function(params){
        return inside.post(`/ti/upgradetinotifyorder`,params)
    },
    //新增接收方式获取微信二维码
    genwechatqr:function(params){
        return inside.post(`/ti/genwechatqr`,params)
    },
    //ssl监控饼图数据
    getstatisticinfo:function(params){
        return inside.post(`/sslmonitor/getstatisticinfo`,params)
    },
    //添加到监控
    addsite:function(params){
        return inside.post(`/sslmonitor/addsite`,params)
    },
    //获取证书监控列表
    getsslmonitorlist:function(params){
        return inside.post(`/sslmonitor/getlist`,params)
    },
    //获取证书监控列表
    delsite:function(params){
        return inside.post(`/sslmonitor/delsite`,params)
    },
    //监控横幅数据信息
    getmonitortitleinfo:function(params){
        return inside.post(`/sslmonitor/getmonitortitleinfo`,params)
    },
    //监控开或者关
    editismonitor:function(params){
        return inside.post(`/sslmonitor/editismonitor`,params)
    },
    //监控开或者关
    certdetails:function(params){
        return inside.post(`/sslmonitor/certinfo`,params)
    },
    //重新检查证书
    certrecheck:function(params){
        return inside.post(`/sslmonitor/recheck`,params)
    },
    //网址安全申请
    websafeapply:function(params){
        return inside.post(`/websafe/apply`,params)
    },
    //网址安全申请列表
    websafelist:function(params){
        return inside.post(`/websafe/getlist`,params)
    },
    //信息初审
    firsttrial:function(params){
        return inside.post(`/websafe/firsttrial`,params)
    },
    //开始验证网站
    websafestartverify:function(params){
        return inside.post(`/websafe/startverify`,params)
    },
    //验证网站
    verifywebsite:function(params){
        return inside.post(`/websafe/verifywebsite`,params)
    },
    //初始化订单基本信息
    initorder:function(params){
        return inside.post(`/websafe/initorder`,params)
    },
    //创建网站订单信息
    websafecreateorder:function(params){
        return inside.post(`/websafe/createorder`,params)
    },
    //获取未支付订单
    getunpayorderinfo:function(params){
        return inside.post(`/order/getunpayorderinfo`,params)
    },
    //网站安全提交的基本信息
    websafegetinfo:function(params){
        return inside.post(`/websafe/getinfo`,params)
    },
    //修改网站安全提交的基本信息
    updateapply:function(params){
        return inside.post(`/websafe/updateapply`,params)
    },
    //网址安全续费
    websafereneworder:function(params){
        return inside.post(`/websafe/reneworder`,params)
    },
    //获取挂标代码
    websafegetcode:function(params){
        return inside.post(`/websafe/getcode`,params)
    },
    //获取公司列表
    helpgetcompanylist:function(params){
        return inside.post(`/help/getcompanylist`,params)
    },

    /**
     * 白帽API
     */
    //获取用户信息
    getwhinfo:function () {
        return inside.get(`/whinfo/getwhinfo`)
    },
    //白帽登陆
    whlogin:function (params) {
        return inside.post(`/reg/login`,params)
    },
    //获取漏洞列表
    getbuglist:function (params) {
        return inside.post(`/whinfo/getbuglist`,params)
    },
    //获取厂商列表
    getcompanylist:function (params) {
        return inside.post(`/whinfo/getcompanylist`,params)
    },
    //礼品列表
    getwhorderlist:function (params) {
        return inside.post(`/whinfo/getorderlist`,params)
    },
    //获取厂商详情
    getcompanyforkey:function (params) {
        return inside.post(`/help/getcompanyforkey`,params)
    },
    //添加bug
    addbug:function (params) {
        return inside.post(`/whinfo/addbug`,params)
    },
    //获取bug
    getbugfromkey:function (params) {
        return inside.post(`/whinfo/getbugfromkey`,params)
    },
    //修改个人信息
    modifyinfoc:function (params) {
        return inside.post(`/whinfo/modifyinfoc`,params)
    },
    //上传白帽个人头像
    whuploadheadpic:function (data) {
        return formdata.post(`/whinfo/uploadheadpic`,data,{headers:{"Content-Type":"multipart/form-data"}})
    },
    //获取收货地址列表
    getmyaddr:function (params) {
        return inside.get(`/whinfo/getmyaddr`,params)
    },
    //添加收货地址
    addaddr:function (params) {
        return inside.post(`/whinfo/addaddr`,params)
    },
    //修改收货地址
    modifyaddr:function (params) {
        return inside.post(`/whinfo/modifyaddr`,params)
    },
    //修改收货地址
    deleteaddr:function (params) {
        return inside.post(`/whinfo/deleteaddr`,params)
    },
    //修改银行信息
    modifybankinfo:function (params) {
        return inside.post(`/whinfo/modifybankinfo`,params)
    },
    //白帽修改密码
    whmodifypass:function (params) {
        return inside.post(`/whinfo/modifypass`,params)
    },
    //获取我的积分
    getmycoin:function (params) {
        return inside.get(`/whinfo/getmycoin`,params)
    },
    //获取白帽认证信息
    whinfogetauth:function () {
        return inside.post(`/whinfo/getauth`,{})
    },
    //填写白帽认证信息
    whinfoaddauth:function (params) {
        return inside.post(`/whinfo/addauth`,params)
    },
    //获取白帽认证扫脸二维码
    whinfoaiauthurl:function (params) {
        return inside.post(`/whinfo/aiauthurl`,params)
    },
    //厂商获取漏洞详情
    companyGetBugFromKey:function (params) {
        return inside.post(`/company/getbugfromkey`,params)
    },
    //设置匿名设置
    setupanonymous:function (params) {
        return inside.post(`/whinfo/setupanonymous`,params)
    },
    //获取可以提交漏洞的厂商列表
    getauthcompanyuser:function (params) {
        return inside.post(`/whinfo/getauthcompanyuser`,params)
    },
    //获取漏洞分类
    getbugtype:function (params) {
        return inside.post(`/whinfo/getbugtype`,params)
    },
    //添加预警组
    addtinotifyinfo:function (params) {
        return inside.post(`/ti/addtinotifygroupinfo`,params)
    },
    //获取预警联系人
    gettinotifyacceptinfo:function () {
        return inside.post(`/ti/gettinotifyacceptinfo`)
    },
    //获取预警组列表
    gettinotifygrouplist:function (params) {
        return inside.post(`/ti/gettinotifygrouplist`,params)
    },
    //删除预警列表
    deletetinotifyinfo:function (params) {
        return inside.post(`/ti/deletetinotifyinfo`,params)
    },
    //修改预警列表
    updatetinotifyinfo:function (params) {
        return inside.post(`/ti/updatetinotifygroupinfo`,params)
    },
    //获取情报列表
    gettilist:function (params) {
        return inside.post(`/ti/gettilist`,params)
    },
    //新增指纹
    addtisubscribeinfo:function (params) {
        return inside.post(`/ti/addtisubscribeinfo`,params)
    },
    //指纹列表
    gettisubscribelist:function (params) {
        return inside.post(`/ti/gettisubscribelist`,params)
    },
    //新增接收人
    addtinotifyacceptinfo:function (params) {
        return inside.post(`/ti/addtinotifyacceptinfo`,params)
    },
    //发送邮件验证码
    sendemailcode:function (params) {
        return inside.post(`/veritfycode/sendemailcode`,params)
    },
    //查询威胁情报通知套餐信息
    gettinotifypackageinfo:function (params) {
        return inside.post(`/ti/gettinotifypackageinfo`,params)
    },
    //创建威胁情报订单
    createtinotifyorder:function (params) {
        return inside.post(`/ti/createtinotifyorder`,params)
    },
    //打开威胁情报通知开关
    opentinotify:function (params) {
        return inside.post(`/ti/opentinotify`,params)
    },
    //获取套餐对应每日发送通知上限默认值
    getdefaultlimitvalue:function (params) {
        return inside.post(`/ti/getdefaultlimitvalue`,params)
    },
    //根据接收人查询数据
    gettiacceptinfo:function (params) {
        return inside.post(`/ti/gettiacceptinfo`,params)
    },
    //白帽项目列表
    getprojectlist:function (params) {
        return inside.post(`/project-h/getprojectlist`,params)
    },
    //白帽报名项目
    enroll:function (params) {
        return inside.post(`/project-h/enroll`,params)
    },
    //白帽查看项目详情
    getprojectinfo:function (params) {
        return inside.post(`/project-h/getprojectinfo`,params)
    },
    //白帽我的项目项目
    getmyprojectlist:function (params) {
        return inside.post(`/project-h/getmyprojectlist`,params)
    },



    /**
     * 管理员接口
     */
    //登陆
    adminlogin:function (params) {
        return inside.post(`/reg/adminlogin`,params)
    },
    //获取所有文章列表
    admingetsrclist:function (params) {
        return inside.post(`/help/getsrclist`,params)
    },
    //添加文章
    adminaddsrc:function (params) {
        return inside.post(`/adminnimabi/adminaddsrc`,params)
    },
    //删除文章
    admindelsrc:function (params) {
        return inside.post(`/adminnimabi/delsrc`,params)
    },
    //修改文章
    adminmodifysrc:function (params) {
        return inside.post(`/adminnimabi/modifysrc`,params)
    },
    //厂商列表
    adminCompanylist:function (params) {
        return inside.post(`/adminnimabi/getcompanylist`,params)
    },
    //封锁厂商
    adminlockcompany:function (params) {
        return inside.post(`/adminnimabi/adminlockcompany`,params)
    },
    //封锁厂商域名
    adminpasscompanydomain:function (params) {
        return inside.post(`/adminnimabi/adminpasscompanydomain`,params)
    },
    //公司BUG是否有权限自己审核
    adminbugcompany:function (params) {
        return inside.post(`/adminnimabi/adminbugcheckcompany`,params)
    },
    //企业状态封锁
    adminpasscompany:function (params) {
        return inside.post(`/adminnimabi/adminpasscompany`,params)
    },
    //获取文章详情
    adminsrcbykey:function (params) {
        return inside.post(`/help/getsrcbykey`,params)
    },
    //获取所有公司列表
    adminwhacklist:function (params) {
        return inside.post(`/adminnimabi/getwhacklist`,params)
    },
    //封锁白帽
    adminlockwhaker:function (params) {
        return inside.post(`/adminnimabi/adminlockwhaker`,params)
    },
    //邀请用户
    admininvitecode:function (params) {
        return inside.post(`/adminnimabi/produceinvitecode`,params)
    },
    //获取所有bug
    adminbuglist:function (params) {
        return inside.post(`/adminnimabi/getbuglist`,params)
    },
    //审核漏洞
    admincheckbug:function (params) {
        return inside.post(`/adminnimabi/adminncheckbug`,params)
    },
    //审核漏洞
    admingetbugfromkey:function (params) {
        return inside.post(`/adminnimabi/getbugfromkey`,params)
    },
    //管理员查询漏洞
    admingetbugfromsnid:function (params) {
        return inside.post(`/adminnimabi/getbugfromsnid`,params)
    },
    //管理员获取白帽列表 支持模糊搜索并分页
    gethackuser:function (params) {
        return inside.post(`/project-a/gethackuser`,params)
    },
    //管理员邀请参加项目
    projectInvite:function (params) {
        return inside.post(`/project-a/invite`,params)
    },
    //结束项目
    projectEnd:function (params) {
        return inside.post(`/project-a/end`,params)
    },
    //开启项目
    projectOpen:function (params) {
        return inside.post(`/project-a/open`,params)
    },
    //暂停项目
    projectSuspend:function (params) {
        return inside.post(`/project-a/suspend`,params)
    },
    //创建项目
    projectCreate:function (params) {
        return inside.post(`/project-a/create`,params)
    },
    //审核用户
    projectExamineUser:function (params) {
        return inside.post(`/project-a/examine`,params)
    },
    //获取项目期数
    projectno:function (params) {
        return inside.post(`/project-a/getprojectno`,params)
    },
    //结算bug
    adminoverbug:function (params) {
        return inside.post(`/adminnimabi/adminoverbug`,params)
    },
    //仪表盘
    getcompanyinfo:function () {
        return inside.get(`/adminnimabi/getcompanyinfo`)
    },
    //获取实名认证信息
    getcompanyinfoandauthinfo:function (params) {
        return inside.post(`/adminnimabi/getcompanyinfoandauthinfo`,params)
    },
    //审核认证信息
    examineauthinfo:function (params) {
        return inside.post(`/adminnimabi/examineauthinfo`,params)
    },
    //修改bug
    adminmodifybug:function (params) {
        return inside.post(`/adminnimabi/adminmodifybug`,params)
    },
    //管理员获取安全服务列表
    admingetsafetylist:function (params) {
        return inside.post(`/safety-a/getsafetylist`,params)
    },
    //查询测试项目列表
    queryssitestinfo:function (params) {
        return inside.post(`/safety-a/queryssitestinfo`,params)
    },
    //生成报告
    createssi:function (params) {
        return inside.post(`/safety-a/createssi`,params)
    },
    //获取报告详情
    queryssi:function (params) {
        return inside.post(`/safety-a/queryssi`,params)
    },
    //用于UE图片上传
    apiUpload:function (params) {
        return axios.post(`/uploads/upload`,params)
    },
    //威胁情报列表
    getthreatintelligencelist:function (params) {
        return inside.post(`/ti-a/getthreatintelligencelist`,params)
    },
    //新增威胁情报
    addthreatintelligence:function (params) {
        return inside.post(`/ti-a/addthreatintelligence`,params)
    },
    //威胁情报详情
    getthreatintelligence:function (params) {
        return inside.post(`/ti-a/getthreatintelligence`,params)
    },
    //编辑威胁情报
    updatethreatintelligence:function (params) {
        return inside.post(`/ti-a/updatethreatintelligence`,params)
    },
    //申请安全服务
    safetyapply:function (params) {
        return inside.post(`/safety-a/apply`,params)
    },
    //查询实名认证审核过的公司列表
    admingetauthcompanyuser:function (params) {
        return inside.post(`/safety-a/getauthcompanyuser`,params)
    },
    //微信二维码登录
    getwechatqrcode:function () {
        return inside.get(`/wxreg/getwechatqrcode`)
    },
    //管理员获取订单列表
    adminorderlist:function (params) {
        return inside.post(`/order-a/getlist`,params)
    },
    //管理员充值记录
    adminRecharge:function (params) {
        return inside.post(`/wallet-a/getlist`,params)
    },
    //管理员给用户充值
    adminUserRecharge:function (params) {
        return inside.post(`/wallet-a/recharge`,params)
    },
    //管理员获取src列表
    adminGetSrc:function (params) {
        return inside.post(`/src-a/getlist`,params)
    },
    //管理员审核品牌
    examinecompany:function (params) {
        return inside.post(`/src-a/examinecompany`,params)
    },
    //管理员审核域名
    examinecompanydomain:function (params) {
        return inside.post(`/src-a/examinecompanydomain`,params)
    },
    //通用获取帮助中心一级分类
    getsrctypelist:function () {
        return inside.get(`/help/getsrctypelist`)
    },
    //通用获取帮助中心二级分类
    getsrcsubtypelist:function (params) {
        return inside.post(`/help/getsrcsubtypelist`,params)
    },
    //获取优惠券
    getcoupon:function (params) {
        return inside.post(`/voucher-a/getlist`,params)
    },
    //获取挂标
    getsafetycode:function (params) {
        return inside.post(`/safety/getsafetycode`,params)
    },
    //废除优惠券
    abolishcoupon:function (params) {
        return inside.post(`/voucher-a/invalid`,params)
    },
    //创建优惠券
    createcoupon:function (params) {
        return inside.post(`/voucher-a/create`,params)
    },
    //获取客情列表
    customerlist:function (params) {
        return inside.post(`/customer-a/getlist`,params)
    },
    //获取跟进记录
    getrecords:function (params) {
        return inside.post(`/customer-a/getrecords`,params)
    },
    //添加跟进
    addrecord:function (params) {
        return inside.post(`/customer-a/addrecord`,params)
    },
    //修改跟进状态
    updatestate:function (params) {
        return inside.post(`/customer-a/updatestate`,params)
    },
    //获取信任列表
    adminwebsitelist:function (params) {
        return inside.post(`/website-a/getlist`,params)
    },
    //人工添加
    manualinput:function (params) {
        return inside.post(`/customer-a/manualinput`,params)
    },
    //https
    https:function (params) {
        return inside.post(`/https-a/getlist`,params)
    },
    //https
    addhttps:function (params) {
        return inside.post(`/https-a/add`,params)
    },
    //https编辑
    edithttps:function (params) {
        return inside.post(`/https-a/update`,params)
    },
    //吊销
    adminwebsiterevoke:function (params) {
        return inside.post(`/website-a/revoke`,params)
    },
    //审核
    websiteexamine:function (params) {
        return inside.post(`/website-a/examine`,params)
    },
    //信任中心跟进记录
    websitaddrecord:function (params) {
        return inside.post(`/website-a/addrecord`,params)
    },
    //添加跟进记录
    awebsiteaddrecord:function (params) {
        return inside.post(`/website-a/addrecord`,params)
    },
    //确认修复BUG
    confirmrepairbug:function (params) {
        return inside.post(`/company/confirmrepairbug`,params)
    },
    //忽略bug
    ignorebug:function (params) {
        return inside.post(`/company/ignorebug`,params)
    },
    //白帽确认bug是否修复
    whignorebug:function (params) {
        return inside.post(`/whinfo/retestbug`,params)
    },
    //查看跟进记录
    awebsitegetrecords:function (params) {
        return inside.post(`/website-a/getrecords`,params)
    },
    //查看跟进记录
    updattrust:function (params) {
        return inside.post(`/website-a/updateicp`,params)
    },
    //获取企业认证更近记录
    adminfollowupgetrecords:function (params) {
        return inside.post(`/followup-a/getrecords`,params)
    },
    //获取企业认证更近记录
    adminfollowupgetrecordsAdd:function (params) {
        return inside.post(`/followup-a/addrecord`,params)
    },
    //申请开发者
    developerapply:function (params) {
        return inside.post(`/company/developer/apply`,params)
    },
    //查看密钥
    developerget:function (params) {
        return inside.post(`/company/developer/get`,params)
    },
    //重置密钥
    developerreset:function (params) {
        return inside.post(`/company/developer/reset`,params)
    },
    //获取人脸识别链接地址
    aiauthurl:function (params) {
        return inside.post(`/userauth/aiauthurl`,params)
    },
    //图片链接获取文字
    imgocr:function (params) {
        return inside.post(`/userauth/imgocr`,params)
    },
    //仪表盘统计图表
    bugstatistics:function (params) {
        return inside.post(`/company/bugstatistics`,params)
    },
    //获取城市
    cities:function () {
        return axios.get(`/cities/cities.json`)
    },
    //获取待续费订单
    getrenewordertopten:function (params) {
        return inside.post(`/order/getrenewordertopten`,params)
    },
    //我的api列表
    apimylist:function (params) {
        return inside.post(`/api/my/list`,params)
    },
    //api分类
    apitype:function () {
        return inside.get(`/api/store/type/list`)
    },
    //所以API列表
    apilist:function (params) {
        return inside.post(`/api/store/list`,params)
    },
    //API订单详情
    apiOrderInfo:function (params) {
        return inside.post(`/api/order/info`,params)
    },
    //重置appkey
    resetappkey:function (params) {
        return inside.post(`/api/my/reset/appkey`,params)
    },
    //IP白名单
    apiwhitelist:function (params) {
        return inside.post(`/api/white/list`,params)
    },
    //新增IP白名单
    apiwhiteadd:function (params) {
        return inside.post(`/api/white/add`,params)
    },
    //移除IP
    apiwhitedel:function (params) {
        return inside.post(`/api/white/del`,params)
    },
    //api图表
    apiusechart:function (params) {
        return inside.post(`/api/my/usechart`,params)
    },
    //api详情
    apiinfo:function (params) {
        return inside.post(`/api/my/info`,params)
    },
    //添加公司折扣
    adddiscount:function (params) {
        return inside.post(`/sslsdk-a/adddiscount`,params)
    },
    //搜索公司
    searchcompany:function (params) {
        return inside.post(`/sslsdk-a/searchcompany`,params)
    },
    //修改状态
    updateflag:function (params) {
        return inside.post(`/sslsdk-a/updateflag`,params)
    },
    // 获取公司折扣
    getdiscount:function (params) {
        return inside.post(`/sslsdk-a/getdiscount`,params)
    },
    // 修改公司折扣
    updatediscount:function (params) {
        return inside.post(`/sslsdk-a/updatediscount`,params)
    },
    // 获取跟进信息
    getremark:function (params) {
        return inside.post(`/sslsdk-a/getremark`,params)
    },
    // 新增备注
    addremark:function (params) {
        return inside.post(`/sslsdk-a/addremark`,params)
    },
    //查询价格
    getpricelist:function () {
        return inside.get(`/sslsdk-a/getpricelist`)
    },
    //ssl代理商列表
    sslsdk_a_list:function (params) {
        return inside.post(`/sslsdk-a/getlist`,params)
    },
    //api测试请求
    textApi:function(options){
        if(options.type==='get' || options.type==='GET'){
            options.params={params:options.params}
        }
        return axios[options.type](options.url,options.params)
    },
    //退出登录
    loginout:function () {
        let userInf=localStorage.getItem('userInf');
        if(userInf){
            userInf=JSON.parse(userInf);
        }
        if(userInf.userType==1){
            return inside.get(`/whinfo/loginout`);
        }
        if(userInf.userType==2){
            return inside.get(`/company/loginout`);
        }
        if(userInf.userType==3){
            return inside.get(`/adminnimabi/loginout`);
        }
    },
    //获取AK
    getaklist:function (params) {
        return inside.post(`/akmanager/getaklist`,params)
    },
    //新增AK
    addak:function (params) {
        return inside.post(`/akmanager/addakvalue`,params)
    },
    // 推送
    postakfinfo:function (params) {
        return inside.post(`/akmanager/postakfinfo`,params)
    },
    // 校验dns
    checkdns:function (params) {
        return inside.post(`/akmanager/checkdns`,params)
    },
    // 校验dns
    vailddns:function (params) {
        return inside.post(`/akmanager/vailddns`,params)
    },
    // 推送日志
    getpostdnslog:function (params) {
        return inside.post(`/akmanager/getpostdnslog`,params)
    },
    // 删除AK
    deleteakvalue:function (params) {
        return inside.post(`/akmanager/deleteakvalue`,params)
    },
    //修改
    updateakvalue:function (params) {
        return inside.post(`/akmanager/updateakvalue`,params)
    },
    //设置推送配置
    setsslpushconfig:function (params) {
        return inside.post(`/akmanager/setsslpushconfig`,params)
    },
    //赠送
    giftcompanysrc:function (params) {
        return inside.post(`/src-a/giftcompanysrc `,params)
    },
    //代码签名列表
    codeSigningList:function (params) {
        return inside.post(`/customer-a/getcodesignlist`,params)
    },
    //新增代码签名
    addCodeSigning:function (params) {
        return inside.post(`/customer-a/codesignadd`,params)
    },
    //编辑代码签名
    codesignedit:function (params) {
        return inside.post(`/customer-a/codesignedit`,params)
    },
    //代码签名备注
    codesignremark:function (params) {
        return inside.post(`/followup-a/addrecord`,params)
    },
    // 备注列表
    codesignremarklist:function (params) {
        return inside.post(`/followup-a/getrecords`,params)
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/http.js